/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

// =================================================================

//(function() {
// Add custom code below this line
// Update Variant Price on collection pages (Were previously showing all variant option sizes on certain collection pages)
// 
//   (() => {
//   const grid =
//     document.querySelector('[data-products-grid]') ||
//     document.querySelector('.collection__products, .product-grid') ||
//     document.body;
//   if (!grid) return;

//   // price element + original text caches
//   const priceElMap = new WeakMap();
//   const originalMap = new WeakMap();

//   const nfCache = new Map();
//   const fmt = (minor, currency) => {
//     let nf = nfCache.get(currency);
//     if (!nf) {
//       try { nf = new Intl.NumberFormat(undefined, { style:'currency', currency }); }
//       catch { nf = { format: n => (n / 100).toFixed(2) }; }
//       nfCache.set(currency, nf);
//     }
//     return nf.format(minor / 100);
//   };

//   const getPriceEl = (card) => {
//     let el = priceElMap.get(card);
//     if (!el) {
//       el = card.querySelector('.new-price');
//       if (el) priceElMap.set(card, el);
//     }
//     return el;
//   };

//   // rAF-batched writes
//   let queued = false, writes = [];
//   const enqueue = fn => { writes.push(fn); if (!queued) { queued = true; requestAnimationFrame(() => { let f; while ((f = writes.shift())) f(); queued = false; }); } };

//   function showPrice(card, minor, currency) {
//     const el = getPriceEl(card);
//     if (!el) return;
//     if (!originalMap.has(card)) originalMap.set(card, el.textContent);
//     const nextText = `From ${fmt(minor, currency)}`;
//     if (el.textContent === nextText) return;
//     enqueue(() => { el.textContent = nextText; });
//   }

//   function revertPrice(card) {
//     const el = getPriceEl(card);
//     const original = originalMap.get(card);
//     if (!el || !original || el.textContent === original) return;
//     enqueue(() => { el.textContent = original; });
//   }

//   // Use the theme’s product cache if available
//   const getProductViaTheme = (handle, gridSwatchEl) => {
//     // 1) If the GridSwatch instance already has .product populated, use it.
//     const instProduct = gridSwatchEl && gridSwatchEl.product;
//     if (instProduct) return Promise.resolve(instProduct);

//     // 2) Otherwise call the same helper the theme uses (usually cached internally).
//     if (typeof window.fetchProduct === 'function') {
//       return window.fetchProduct(handle);
//     }

//     // 3) Last resort: Shopify’s built-in JSON endpoint (one-time per handle; browser caches).
//     return fetch(`/products/${handle}.js`).then(r => r.ok ? r.json() : null).catch(() => null);
//   };

//   async function handleSwatch(swatch) {
//     // Theme puts variant ID on both data-variant and data-swatch-variant
//     const variantId = swatch.dataset.variant || swatch.dataset.swatchVariant;
//     if (!variantId) return;

//     const gridSwatch = swatch.closest('grid-swatch');
//     const handle = gridSwatch && gridSwatch.getAttribute('data-swatch-handle');
//     if (!handle) return;

//     const card = swatch.closest('[data-grid-item-id]') || swatch.closest('.product-item, .product-card');
//     if (!card) return;

//     const product = await getProductViaTheme(handle, gridSwatch);
//     if (!product) return;

//     const v = (product.variants || []).find(x => String(x.id) === String(variantId));
//     if (!v || !Number.isFinite(v.price) || v.price <= 0) return;

//     const currency =
//       (window.Shopify && Shopify.currency && Shopify.currency.active) ||
//       (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.currency) ||
//       'USD';

//     showPrice(card, v.price, currency);
//   }

//   // Delegated events: hover/focus/click + revert on leave
//   grid.addEventListener('pointerover', e => {
//     const swatch = e.target.closest('[data-swatch-button]');
//     if (!swatch || swatch.contains(e.relatedTarget)) return;
//     handleSwatch(swatch);
//   }, { passive: true });

//   grid.addEventListener('pointerout', e => {
//     const holder = e.target.closest('grid-swatch');
//     if (!holder || holder.contains(e.relatedTarget)) return;
//     const card = holder.closest('[data-grid-item-id]') || holder.closest('.product-item, .product-card');
//     if (card) revertPrice(card);
//   }, { passive: true });

//   grid.addEventListener('focusin', e => {
//     const swatch = e.target.closest('[data-swatch-button]');
//     if (swatch) handleSwatch(swatch);
//   });
//   grid.addEventListener('focusout', e => {
//     const holder = e.target.closest('grid-swatch');
//     if (holder) {
//       const card = holder.closest('[data-grid-item-id]') || holder.closest('.product-item, .product-card');
//       if (card) revertPrice(card);
//     }
//   });
//   grid.addEventListener('click', e => {
//     const swatch = e.target.closest('[data-swatch-button]');
//     if (swatch) handleSwatch(swatch);
//   });
// })();


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
//})();

// =================================================================

/**
 * Ring bundle discount — cart page display fix.
 *
 * WORKAROUND: the automatic discount is created a few seconds after the variant
 * is added to the cart, so the stored cart has no discount and a plain GET just
 * replays it. This polls with a real mutation until the discount lands.
 * The proper fix is server-side: confirm the discount is ACTIVE before adding
 * the variant to the cart.
 */

// (function () {
//   'use strict';

//   const SETTINGS = {
//     productType: 'ring',
//     attempts: 5,
//     delay: 1000,
//     recalcAttribute: '__ring_discount_recalc',
//   };

//   // 1. Cart page only.
//   if (!window.location.pathname.replace(/\/+$/, '').endsWith('/cart')) return;
//   if (window.__barkevsRingDiscountStarted) return;
//   window.__barkevsRingDiscountStarted = true;

//   const root = window.Shopify?.routes?.root || '/';
//   const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

//   console.log("custom");
  
//   // Single place to wire up monitoring.
//   function report(message, detail) {
//     console.warn(`[Barkevs discount] ${message}`, detail ?? '');
//     // window.Sentry?.captureMessage(`[Barkevs discount] ${message}`, {level: 'warning', extra: {detail}});
//     // window.Rollbar?.warning(`[Barkevs discount] ${message}`, {detail});
//   }

//   // 2. Rings in the cart.
//   const rings = (cart) =>
//     (cart.items || []).filter((item) => (item.product_type || '').toLowerCase() === SETTINGS.productType);

//   // 3. Rings with no matching discount. Matches on product ID appearing anywhere
//   //    in the discount title, so a sitewide sale is not mistaken for this one.
//   const undiscounted = (cart) =>
//     rings(cart).filter(
//       (item) =>
//         !(item.discounts || []).some(
//           (discount) => typeof discount.title === 'string' && discount.title.includes(String(item.product_id))
//         )
//     );

//   async function json(url, options) {
//     const response = await fetch(url, options);
//     if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
//     return response.json();
//   }

//   //Use try/catch instead
//   //const loadCart = () => json(`${root}cart.js`, {headers: {Accept: 'application/json'}, cache: 'no-store'});

//   async function loadCart() {
//     const options = {
//       headers: {Accept: 'application/json'},
//       cache: 'no-store',
//     };

//     try {
//       return await json(`${root}cart.js`, options);
//     } catch (error) {
//       report('initial cart request failed; retrying', error);
//       await wait(SETTINGS.delay);
//       return json(`${root}cart.js`, options);
//     }
//   }

//   // A *changed* attribute value is a real mutation, which is what forces Shopify
//   // to re-evaluate automatic discounts. A GET alone replays the stored cart.
//   const recalculate = () =>
//     json(`${root}cart/update.js`, {
//       method: 'POST',
//       headers: {'Content-Type': 'application/json', Accept: 'application/json'},
//       body: JSON.stringify({attributes: {[SETTINGS.recalcAttribute]: String(Date.now())}}),
//     });

//   const render = () => document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));

//   async function run() {
//     let cart = await loadCart();

//     // Nothing to do: no rings, or every ring already discounted. Render before returning in case of stale data.
//     if (!undiscounted(cart).length) return render();

//     // 4. Poll once a second for five seconds, or until every ring is discounted.
//     for (let attempt = 1; attempt <= SETTINGS.attempts; attempt++) {
//       await wait(SETTINGS.delay);

//       try {
//         cart = await recalculate();
//       } catch (error) {
//         report(`recalculation attempt ${attempt}/${SETTINGS.attempts} failed`, error);
//         continue;
//       }

//       if (!rings(cart).length) return; // cart emptied mid-poll
//       if (!undiscounted(cart).length) return render();
//     }

//     report(`${undiscounted(cart).length} ring(s) undiscounted after ${SETTINGS.attempts} attempts`, {
//       token: cart.token,
//       productIds: undiscounted(cart).map((item) => item.product_id),
//     });

//     render(); // some rings may have landed even if not all did
//   }

//   run().catch((error) => report('unexpected failure', error));
// })();


// =================================================================

/* ==========================================================================
   Barkev's mega menu
   Behavior for snippets/barkevs-mega-menu.liquid (sections/header-barkevs.liquid).
   Self-contained: it defines <barkevs-mega-menu> and does nothing on a page without it,
   so switching back to the theme's original header leaves this code inactive.

   - Desktop (1024px+): a panel opens on mouse hover after a short delay, on the arrow
     button (keyboard and screen readers), or on tap (touch: first tap opens, second
     follows the link). Esc, clicking outside, or moving the pointer away closes it.
   - Under 1024px: the hamburger in this header opens the drawer. Its clicks are handled
     here (before the theme's own handler), so the drawer opens even if another menu
     drawer, such as the theme's "Mobile menu" section, is still on the page.
     Tablets (750-1023px) get two panes; phones drill down into a panel with closed sections.
   - Analytics: every menu link click is published as "barkevs_menu_click"
     (Shopify customer events) and pushed to window.dataLayer as "menu_click" when present.
   ========================================================================== */
(function () {
  'use strict';

  if (!('customElements' in window) || customElements.get('barkevs-mega-menu')) return;

  const DESKTOP_QUERY = window.matchMedia('(min-width: 1024px)');
  const TABLET_QUERY = window.matchMedia('(min-width: 750px)');
  const OPEN_DELAY = 120; // ms a mouse must rest on an item before its panel opens
  const CLOSE_DELAY = 200; // ms grace period after the mouse leaves
  const DRAWER_SPEED = 300; // ms, matches --bmm-speed in barkevs-mega-menu.css
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  class BarkevsMegaMenu extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('header-component');
      this.shell = this.querySelector('[data-bmm-shell]');
      this.underlay = this.querySelector('[data-bmm-underlay]');
      this.items = Array.from(this.querySelectorAll('[data-bmm-item]'));
      this.panelItems = this.items.filter((item) => item.querySelector('[data-bmm-panel]'));
      this.openItem = null; // desktop: item whose panel is open
      this.activeItem = null; // drawer: item whose panel is shown
      this.drawerOpen = false;
      this.trigger = null;
      this.timer = 0;
      this.pointerType = 'mouse';
      this.controller = new AbortController();

      const options = {signal: this.controller.signal};

      this.addEventListener('theme:drawer:toggle', (event) => this.toggleDrawer(event.detail?.button), options);
      this.header?.addEventListener('click', (event) => this.onHamburgerClick(event), {...options, capture: true});
      this.addEventListener('click', (event) => this.onClick(event), options);
      this.addEventListener('pointerdown', (event) => (this.pointerType = event.pointerType), {...options, passive: true});
      this.addEventListener('keydown', (event) => this.onKeydown(event), options);
      this.addEventListener('focusout', (event) => this.onFocusOut(event), options);
      this.underlay?.addEventListener('click', () => this.closeAll(), options);

      this.panelItems.forEach((item) => {
        item.addEventListener('pointerenter', (event) => this.onPointerEnter(event, item), options);
        item.addEventListener('pointerleave', (event) => this.onPointerLeave(event), options);
      });

      document.addEventListener('keydown', (event) => this.onDocumentKeydown(event), options);
      document.addEventListener('theme:cart-drawer:open', () => this.closeDrawer(false), options);
      document.addEventListener('shopify:block:select', (event) => this.onEditorSelect(event), options);
      document.addEventListener('shopify:block:deselect', () => this.closeAll(), options);
      DESKTOP_QUERY.addEventListener('change', () => this.updateMode(), options);
      TABLET_QUERY.addEventListener('change', () => this.updateMode(), options);

      // The theme switches to its mobile header (class js__show__mobile) when the bar doesn't fit.
      if (this.header) {
        this.headerObserver = new MutationObserver(() => this.updateMode());
        this.headerObserver.observe(this.header, {attributes: true, attributeFilter: ['class']});
      }

      this.updateMode();
      this.classList.add('bmm--js');
    }

    disconnectedCallback() {
      this.controller.abort();
      this.headerObserver?.disconnect();
      clearTimeout(this.timer);
      if (this.drawerOpen) document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
      this.header?.classList.remove('bmm-is-open', 'meganav--visible');
    }

    get mode() {
      return this.dataset.bmmMode;
    }

    updateMode() {
      const mobileHeader = this.header?.classList.contains('js__show__mobile');
      const mode = DESKTOP_QUERY.matches && !mobileHeader ? 'desktop' : TABLET_QUERY.matches ? 'tablet' : 'phone';
      if (mode === this.mode) return;

      this.closePanel();
      this.deactivate();
      this.dataset.bmmMode = mode;

      if (mode === 'desktop') {
        this.closeDrawer(false);
      } else if (this.drawerOpen && mode === 'tablet') {
        this.activate(this.panelItems[0], false);
      }
    }

    /* ---------- Desktop panels ---------- */

    onPointerEnter(event, item) {
      if (this.mode !== 'desktop' || event.pointerType !== 'mouse') return;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.openPanel(item), this.openItem ? 0 : OPEN_DELAY);
    }

    onPointerLeave(event) {
      if (this.mode !== 'desktop' || event.pointerType !== 'mouse') return;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.closePanel(), CLOSE_DELAY);
    }

    openPanel(item) {
      clearTimeout(this.timer);
      if (!item || this.openItem === item) return;
      if (this.openItem) this.setExpanded(this.openItem, 'is-open', false);

      const barBottom = `${Math.round(this.shell.getBoundingClientRect().bottom)}px`;
      this.style.setProperty('--bmm-panel-top', barBottom);
      this.style.setProperty('--bmm-underlay-top', barBottom);

      this.openItem = item;
      this.setExpanded(item, 'is-open', true);
      this.classList.add('is-panel-open');
      // The theme's own "dropdown open" class: gives a transparent header its background.
      this.header?.classList.add('meganav--visible');
    }

    closePanel(returnFocus = false) {
      clearTimeout(this.timer);
      const item = this.openItem;
      if (!item) return;

      this.openItem = null;
      this.setExpanded(item, 'is-open', false);
      this.classList.remove('is-panel-open');
      this.header?.classList.remove('meganav--visible');
      if (returnFocus) item.querySelector('[data-bmm-toggle]')?.focus();
    }

    onFocusOut(event) {
      if (this.mode !== 'desktop' || !this.openItem) return;
      const next = event.relatedTarget;
      if (next ? !this.openItem.contains(next) : !this.openItem.matches(':hover')) this.closePanel();
    }

    /* ---------- Drawer (tablet and phone) ---------- */

    // Runs in the capture phase on this header, before the theme's listener on the button.
    // The theme sends the toggle to the first [data-drawer] on the page, which may not be this menu.
    onHamburgerClick(event) {
      const button = event.target.closest('[data-drawer-toggle]');
      if (!button || this.mode === 'desktop') return;

      event.preventDefault();
      event.stopPropagation();
      this.toggleDrawer(button);
    }

    toggleDrawer(button) {
      if (this.drawerOpen) this.closeDrawer();
      else this.openDrawer(button);
    }

    openDrawer(button) {
      if (this.mode === 'desktop' || this.drawerOpen) return;

      this.drawerOpen = true;
      this.trigger = button || null;
      this.style.setProperty('--bmm-underlay-top', '0px');
      this.shell.setAttribute('role', 'dialog');
      this.shell.setAttribute('aria-modal', 'true');
      this.shell.setAttribute('aria-label', this.shell.querySelector('.bmm__head-title')?.textContent.trim() || 'Menu');
      this.header?.classList.add('bmm-is-open');
      this.classList.add('is-open');
      this.trigger?.setAttribute('aria-expanded', 'true');
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));

      if (this.mode === 'tablet') this.activate(this.activeItem || this.panelItems[0], false);
      this.shell.querySelector('[data-bmm-close]')?.focus({preventScroll: true});
    }

    closeDrawer(returnFocus = true) {
      if (!this.drawerOpen) return;

      this.drawerOpen = false;
      this.classList.remove('is-open');
      this.shell.removeAttribute('role');
      this.shell.removeAttribute('aria-modal');
      this.shell.removeAttribute('aria-label');
      this.trigger?.setAttribute('aria-expanded', 'false');
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
      if (returnFocus) this.trigger?.focus({preventScroll: true});

      // Let the drawer slide out before lowering the header and resetting the drill-down.
      setTimeout(() => {
        if (this.drawerOpen) return;
        this.header?.classList.remove('bmm-is-open');
        if (this.mode === 'phone') this.deactivate();
      }, DRAWER_SPEED);
    }

    activate(item, moveFocus = true) {
      if (!item) return;
      if (this.activeItem && this.activeItem !== item) this.setExpanded(this.activeItem, 'is-active', false);

      this.activeItem = item;
      this.setExpanded(item, 'is-active', true);
      this.classList.toggle('is-drilled', this.mode === 'phone');
      if (moveFocus && this.mode === 'phone') item.querySelector('[data-bmm-back]')?.focus({preventScroll: true});
    }

    deactivate(returnFocus = false) {
      const item = this.activeItem;
      this.classList.remove('is-drilled');
      if (!item) return;

      this.activeItem = null;
      this.setExpanded(item, 'is-active', false);
      if (returnFocus) item.querySelector('[data-bmm-toggle]')?.focus({preventScroll: true});
    }

    trapFocus(event) {
      const focusable = Array.from(this.shell.querySelectorAll(FOCUSABLE)).filter(
        (element) => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden'
      );
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    /* ---------- Shared ---------- */

    setExpanded(item, className, expanded) {
      item.classList.toggle(className, expanded);
      item.querySelector('[data-bmm-toggle]')?.setAttribute('aria-expanded', String(expanded));
    }

    closeAll(returnFocus = false) {
      this.closePanel(returnFocus);
      this.closeDrawer(returnFocus);
    }

    onClick(event) {
      const target = event.target;

      const toggle = target.closest('[data-bmm-toggle]');
      if (toggle) {
        const item = toggle.closest('[data-bmm-item]');
        if (this.mode === 'desktop') {
          if (this.openItem === item) this.closePanel();
          else this.openPanel(item);
        } else {
          this.activate(item, this.mode === 'phone');
        }
        return;
      }

      if (target.closest('[data-bmm-back]')) return this.deactivate(true);
      if (target.closest('[data-bmm-close]')) return this.closeDrawer();

      const groupToggle = target.closest('[data-bmm-group-toggle]');
      if (groupToggle) {
        const group = groupToggle.closest('[data-bmm-group]');
        const expanded = !group.classList.contains('is-expanded');
        group.classList.toggle('is-expanded', expanded);
        groupToggle.setAttribute('aria-expanded', String(expanded));
        return;
      }

      // Desktop top-level links: a tap (not a mouse click or the Enter key) opens the panel
      // first, a second tap follows the link. Links set to "#" only open their panel.
      const topLink = target.closest('[data-bmm-top-link]');
      if (topLink && this.mode === 'desktop') {
        const item = topLink.closest('[data-bmm-item]');
        const hasPanel = this.panelItems.includes(item);
        const isTap = event.detail !== 0 && this.pointerType !== 'mouse';
        if (hasPanel && (topLink.getAttribute('href') === '#' || (isTap && this.openItem !== item))) {
          event.preventDefault();
          this.openPanel(item);
          return;
        }
      }

      const link = target.closest('a[data-bmm-track]');
      if (link) this.track(link);
    }

    onKeydown(event) {
      if (event.key === 'Tab' && this.drawerOpen) this.trapFocus(event);
    }

    onDocumentKeydown(event) {
      if (event.key !== 'Escape') return;
      const focusInside = this.contains(document.activeElement);

      if (this.openItem) {
        this.closePanel(focusInside);
      } else if (this.drawerOpen) {
        if (this.mode === 'phone' && this.activeItem && focusInside) this.deactivate(true);
        else this.closeDrawer();
      }
    }

    // Theme editor: selecting a "Menu photo" block opens the panel it belongs to.
    onEditorSelect(event) {
      if (event.detail?.sectionId !== this.dataset.sectionId) return;
      const tile = this.querySelector(`[data-bmm-block-id="${CSS.escape(event.detail.blockId)}"]`);
      const item = tile?.closest('[data-bmm-item]');
      if (!item) return;

      if (this.mode === 'desktop') {
        this.openPanel(item);
      } else {
        this.openDrawer(null);
        this.activate(item, false);
      }
    }

    /* ---------- Analytics ---------- */

    // track(link) {
    //   const detail = {
    //     menu_path: link.dataset.bmmTrack,
    //     menu_level: link.dataset.bmmLevel,
    //     link_url: link.href,
    //     menu_layout: this.mode,
    //   };

    //   try {
    //     window.Shopify?.analytics?.publish?.('barkevs_menu_click', detail);
    //   } catch (error) {
    //     // Analytics must never block navigation.
    //   }

    //   if (Array.isArray(window.dataLayer)) window.dataLayer.push({event: 'menu_click', ...detail});
    // }
    
  }

  customElements.define('barkevs-mega-menu', BarkevsMegaMenu);
})();
